import { Link } from 'react-router-dom'

export interface Stat {
  label: string
  value: string
  /** One short clause of context, where a bare number would not be actionable. */
  note?: string
  /** Where the number leads, when there is a screen that explains it. */
  to?: string
  /** Draws attention only when something is actually wrong; never decoration. */
  tone?: 'plain' | 'warning' | 'danger'
}

/**
 * The numbers that are a sentence rather than a shape.
 *
 * A count of devices, or of alerts open right now, has no trend to show and no parts to compare: it
 * is one figure, and drawing it as a chart with a single bar would be decoration pretending to be
 * information. So it is set large, labeled, and where it means something is wrong, linked to the
 * screen where it can be dealt with.
 */
export function StatTiles({ stats }: { stats: Stat[] }) {
  return (
    <ul className="stat-tiles">
      {stats.map((stat) => {
        const body = (
          <>
            <span className={`stat-value${stat.tone && stat.tone !== 'plain' ? ` ${stat.tone}` : ''}`}>
              {stat.value}
            </span>
            <span className="stat-label">{stat.label}</span>
            {stat.note && <span className="stat-note">{stat.note}</span>}
          </>
        )

        return (
          <li key={stat.label} className="stat-tile">
            {stat.to ? (
              <Link to={stat.to} className="stat-link">
                {body}
              </Link>
            ) : (
              body
            )}
          </li>
        )
      })}
    </ul>
  )
}
